import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { theme } from '../utils/theme';

const CookieConsent = () => {
  const { t } = useTranslation('cookies');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    // Just hide the popup without storing anything in localStorage
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-t border-[#6D9773]/20 shadow-lg z-50 p-4">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm text-[#0C3B2E]">
            {t('message')}{' '}
            {t('readMore')}{' '}
            <Link to="/terms" className="text-[#6D9773] hover:text-[#0C3B2E] underline">
              {t('termsLink')}
            </Link>{' '}
            {t('moreInfo')}
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={handleDecline}
            className={`${theme.button.base} ${theme.button.secondary} ${theme.button.sizes.sm}`}
          >
            {t('declineButton')}
          </button>
          <button
            onClick={handleAccept}
            className={`${theme.button.base} ${theme.button.cta} ${theme.button.sizes.sm}`}
          >
            {t('acceptButton')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;